// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__QQNTq","modalControl":"Button_modalControl__ZxSqn","Small":"Button_Small__uox9q"};